@if (name()) {
  <strong class="cart-order-item-option-group__name">{{ name() }}</strong>
}
<ng-content />
